import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { USER_ROLE_PERMISSIONS_FOR_GUARDS } from 'Src/ng2/routes/route-guards/user-role-permissions-for-route-guards.constant';
import { ShelterIdResolver } from 'Src/ng2/routes/resolvers/shelter-id/shelter-id.resolver';
import { RouteGuards } from 'Src/ng2/routes/route-guards/route-guards';

const routes = [
  {
    path: '',
    // TODO - Consider passing routes through
    // ListComponent to apply template styles
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: '/not-found',
      },
      {
        path: 'attendance-list',
        rolePermissions: USER_ROLE_PERMISSIONS_FOR_GUARDS['shelter/:shelterId/lists/attendance-list'],
        authenticationRequired: true,
        canActivate: [RouteGuards],
        loadChildren: () => import('./attendance/shelter-att-list.module').then(m => m.ShelterAttListModule),
        resolve: {
          shelter: ShelterIdResolver,
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ShelterListRoutingModule {}
